var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "18px", "font-weight": "600" } },
          [_vm._v("📊 质量统计")]
        )
      ]),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-num" }, [
                    _vm._v(_vm._s(_vm.overview.totalQuestions))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("总题目数")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#409EFF" }
                    },
                    [_vm._v(_vm._s(_vm.overview.avgDifficulty))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("平均难度")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#67C23A" }
                    },
                    [_vm._v(_vm._s(_vm.overview.avgDiscrimination))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("平均区分度")
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#E6A23C" }
                    },
                    [_vm._v(_vm._s(_vm.overview.cronbachAlpha))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("信度 (α)")])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { attrs: { shadow: "never" } }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [_c("span", [_vm._v("难度分布")])]
                ),
                _c("div", { staticClass: "chart-container" }, [
                  _c(
                    "div",
                    { staticClass: "bar-chart" },
                    _vm._l(_vm.difficultyDistribution, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "bar-item" },
                        [
                          _c("div", { staticClass: "bar-label" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c("div", { staticClass: "bar-track" }, [
                            _c("div", {
                              staticClass: "bar-fill",
                              style: {
                                width: item.percent + "%",
                                background: _vm.barColors[index]
                              }
                            })
                          ]),
                          _c("div", { staticClass: "bar-value" }, [
                            _vm._v(_vm._s(item.count) + "题")
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { attrs: { shadow: "never" } }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [_c("span", [_vm._v("区分度分布")])]
                ),
                _c("div", { staticClass: "chart-container" }, [
                  _c(
                    "div",
                    { staticClass: "bar-chart" },
                    _vm._l(_vm.discriminationDistribution, function(
                      item,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index, staticClass: "bar-item" },
                        [
                          _c("div", { staticClass: "bar-label" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c("div", { staticClass: "bar-track" }, [
                            _c("div", {
                              staticClass: "bar-fill",
                              style: {
                                width: item.percent + "%",
                                background: _vm.discColors[index]
                              }
                            })
                          ]),
                          _c("div", { staticClass: "bar-value" }, [
                            _vm._v(_vm._s(item.count) + "题")
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { attrs: { shadow: "never" } }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [_c("span", [_vm._v("题型分布")])]
                ),
                _c("div", { staticClass: "chart-container" }, [
                  _c(
                    "div",
                    { staticClass: "pie-legend" },
                    _vm._l(_vm.questionTypeIdDistribution, function(
                      item,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index, staticClass: "pie-item" },
                        [
                          _c("span", {
                            staticClass: "pie-dot",
                            style: {
                              background:
                                _vm.pieColors[index % _vm.pieColors.length]
                            }
                          }),
                          _c("span", { staticClass: "pie-label" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c("span", { staticClass: "pie-value" }, [
                            _vm._v(_vm._s(item.count) + "题")
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { attrs: { shadow: "never" } }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [_c("span", [_vm._v("布鲁姆认知层级分布")])]
                ),
                _c("div", { staticClass: "chart-container" }, [
                  _c(
                    "div",
                    { staticClass: "bar-chart" },
                    _vm._l(_vm.bloomDistribution, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "bar-item" },
                        [
                          _c("div", { staticClass: "bar-label" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c("div", { staticClass: "bar-track" }, [
                            _c("div", {
                              staticClass: "bar-fill",
                              style: {
                                width: item.percent + "%",
                                background: _vm.bloomColors[index]
                              }
                            })
                          ]),
                          _c("div", { staticClass: "bar-value" }, [
                            _vm._v(_vm._s(item.count) + "题")
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "15px" },
          attrs: { shadow: "never" }
        },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v("质量趋势（近30天）")])]
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.qualityTrends, border: "", stripe: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "日期", width: "120" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "avgDifficulty",
                  label: "平均难度",
                  width: "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "avgDiscrimination",
                  label: "平均区分度",
                  width: "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cronbachAlpha",
                  label: "信度 (α)",
                  width: "120"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "expertCvi", label: "效度 (CVI)", width: "120" }
              }),
              _c("el-table-column", {
                attrs: { prop: "newQuestions", label: "新增题目", width: "100" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }